import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ACADEMIC_VIEW_TYPE, FACILITIES_VIEW_TYPE, accountTypes, viewTypeStorageKey } from '../../constants';

interface UserTerm {
    termCampusId: number;
    termSchoolId: number;
    termId: number;
    termCode: string;
    startDate: string;
    endDate: string;
}

interface TermSchool extends UserTerm {
    termSchoolId: number;
    termId: number;
    schoolId: number;
    startDate: string;
    endDate: string;
    code: string;
    termLabel: string;
}

interface GenericObject {
    id: number;
    name: string;
}

interface AppInitialState {
    viewType: string;
    school: GenericObject;
    campus: GenericObject;
    term: UserTerm;
    gridStartTime: string;
    gridEndTime: string;
    schools: Array<GenericObject>;
    campuses: Array<GenericObject>;
    termSchools: Array<TermSchool>;
    eventCRN: string;
}

const appInitialState: AppInitialState = {
    viewType: null,
    term: null,
    gridStartTime: null,
    gridEndTime: null,
    schools: [],
    school: undefined,
    campuses: [],
    campus: undefined,
    termSchools: [],
    eventCRN: null
};

export const appSlice = createSlice({
    name: 'app-slice',
    initialState: appInitialState,
    reducers: {
        setAppState: (state, action) => {
            state.campus = action.payload.campus;
            state.school = action.payload.school;
            state.schools = action.payload.schools;
            state.campuses = action.payload.campuses;
            state.termSchools = action.payload.termSchools;

            state.term = {
                termId: action.payload.term.termId,
                termCampusId: action.payload.term.termCampusId,
                termSchoolId: action.payload.term.termSchoolId,
                termCode: action.payload.term.code,
                startDate: action.payload.term.startDate,
                endDate: action.payload.term.endDate,
            };

            state.gridStartTime = action.payload.gridStartTime;
            state.gridEndTime = action.payload.gridEndTime;

            state.eventCRN = action.payload.eventCRN;
        },
        setViewType: (state, action) => {
            state.viewType = action.payload;
            localStorage.setItem(viewTypeStorageKey, state.viewType);
        },
        setCampus: (state, action) => {
            state.campus = action.payload;
        },
        setSchool: (state, action) => {
            state.school = action.payload;

            //TODO: set the termSchoolId to the most recent term instead of first
            const schoolTerms = state.termSchools.filter((ts) => ts.schoolId === action.payload.id);
            const termSchool = schoolTerms[0];

            state.term = {
                ...state.term,
                termSchoolId: termSchool.termSchoolId,
                termId: termSchool.termId,
                termCode: termSchool.code,
                startDate: termSchool.startDate,
                endDate: termSchool.endDate,
            };
        },
        setTermSchool: (state, action: PayloadAction<TermSchool>) => {
            state.term = {
                ...state.term,
                termSchoolId: action.payload.termSchoolId,
                termId: action.payload.termId,
                termCode: action.payload.code,
                startDate: action.payload.startDate,
                endDate: action.payload.endDate,
            };
        },
        setTermSchools: (state, action) => {
            state.termSchools = action.payload;
        },
        setEventCRN: (state, action) => {
            state.eventCRN = action.payload;
        }
    },
});

// Action creators are generated for each case reducer function
export const { setAppState, setViewType, setSchool, setCampus, setTermSchool, setTermSchools, setEventCRN } = appSlice.actions;

export default appSlice.reducer;
